<template>
    <v-snackbar v-model=showSnackBar :color="color" top right>
        <v-layout row wrap justify-space-between align-start class="pb-0 px-3">
            {{ message }}
            <v-icon @click="closeSnackBar()">close</v-icon>
        </v-layout>
    </v-snackbar>
</template>

<script>

export default {
    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        message: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            showSnackBar: false,
        };
    },
    watch:{
        show: function() {
            this.showSnackBar = this.show;
        },

        showSnackBar: function() {
            if (this.showSnackBar == false){
                this.$emit('closeSnackBar')
            }
        },
    },
    methods: {
        closeSnackBar() {
            this.showSnackBar = false
        },
    }
};
</script>
